import React, { useEffect, useState } from "react"
import { useSiteContext } from "../common/SiteContext"
import { TwoColumnAgentBlade } from "@organic-return/foundation-react/src/components/Blades/TwoColumnAgentBlade"
import { graphql, useStaticQuery } from "gatsby"
import { IAgent } from "@organic-return/foundation-react/src/lib"


const FeaturedAffiliatedAgent = ({ module }) => {
  const data = useStaticQuery(graphql`
    query {
      partners: allAgilityPartners {
        totalCount
        nodes {
          contentID
          customFields {
            agentBrokerageOffice
            agentDashID
            agentFirstName
            agentLastName
            bio
            latitude
            longitude
            photo {
              filesize
              url
            }
            locationName
          }
          path
          extraLocations {
            customFields {
              areaOfExpertise
            }
          }
        }
      }
    }
  `)

  const siteContext = useSiteContext()

  const totalCount = data.partners?.totalCount ?? 0

  const partnerItemIndex = Math.floor(Math.random() * totalCount);
  const partnerItem = data.partners.nodes?.[partnerItemIndex]

  const partner: IAgent = {
    photos: partnerItem?.customFields.photo && [{
      url: partnerItem?.customFields.photo.url
    }],
    bio: partnerItem?.customFields.bio,
    first: partnerItem?.customFields.agentFirstName,
    last: partnerItem?.customFields.agentLastName,
    address: partnerItem?.customFields.locationName && {
      city: partnerItem.customFields.locationName
    },
    expertiseAreas: partnerItem.extraLocations?.map(item => item.customFields.areaOfExpertise)?.filter(area => area?.trim().length > 0)
  }

  const link = partnerItem?.path && {
    label: `Learn About ${partnerItem.customFields.agentFirstName}`,
    url: partnerItem.path
  }

  const [isClient, setClient] = useState(false)
  useEffect(() => {
    setClient(true)
  }, [])

  if (!isClient) return null

  return (
    <TwoColumnAgentBlade
      key={partnerItem.contentID}
      title={module.customFields.title}
      partnerInformation={partner}
      className="mx-auto"
      agentNameClassName="text-4xl"
      agentLocationClassName="lg:ml-32 xl:ml-36 text-lg font-bold"
      link={link}
      layout={module.customFields.layout}
      {...siteContext.globalFeaturedAffiliatedAgentProps}
    />
  )
}

export default FeaturedAffiliatedAgent
